const u = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMG = {
  hero: u("photo-1757924461488-ef9ad0670978", 2400),
  studio: u("photo-1780191751680-cdd89eef7b27"),
  principal: u("photo-1770062422860-92c107ef02cc"),
  joinery:
    "https://static.prod-images.emergentagent.com/jobs/09a6a978-dfc7-49c9-9fe0-e19dbf456077/images/122f954d114cafddddbbb9a2e31a620a6375effe73c50ce4b4656d946589a2ab.jpeg",
  bathroom:
    "https://static.prod-images.emergentagent.com/jobs/09a6a978-dfc7-49c9-9fe0-e19dbf456077/images/95e2b6eaae532c5f7a22a8a0e90219d99170606281075d73f166add5b5edecbe.jpeg",
  narrative: u("photo-1646987916641-1f3c8992daa2"),
  detailOne: u("photo-1564078516393-cf04bd966897"),
};

export const CONTACT = {
  phoneDisplay: "+91 94943 64449",
  whatsapp: "919494364449",
  email: "aurealivingofficial@gmail.com",
  address: "Madhapur, Hyderabad, Telangana",
  hours: "Mon – Sat · 10:00 am – 7:00 pm",
  instagram: "https://www.instagram.com/aurea_living_official",
};

export const whatsappLink = (text =
  "Hello Aurea Living, I would like to discuss an interior design project.") =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(text)}`;

export const STATS = [
  { value: "45+", label: "Homes & workspaces delivered" },
  { value: "1.2L+", label: "Square feet designed & built" },
  { value: "98%", label: "On-time handover, every year" },
];

export const SERVICES = [
  {
    num: "01",
    title: "Turnkey Home Interiors",
    desc: "One team, one contract — civil work, electricals, false ceilings, finishes and furniture, managed end-to-end to a single promised handover date.",
    points: ["Villas & independent homes", "Apartments & penthouses", "Single-window execution & QC"],
    image: u("photo-1704040686413-2c607dbd2f06"),
  },
  {
    num: "02",
    title: "Bespoke Furniture & Joinery",
    desc: "Designed in our atelier, built by master carpenters — fluted panelling, puja units, bars, wardrobes and upholstered pieces that belong to your walls alone.",
    points: ["Custom millwork & panelling", "Loose furniture & upholstery", "Metal, stone & glass detailing"],
    image: IMG.joinery,
  },
  {
    num: "03",
    title: "Modular Kitchens & Wardrobes",
    desc: "Precision-engineered kitchens and storage with German hardware, stone counters and lighting planned around how you actually cook and live.",
    points: ["Ergonomic kitchen planning", "Countertops & backsplash curation", "Appliance & utility integration"],
    image: u("photo-1758448755927-e5c5ae14790c"),
  },
  {
    num: "04",
    title: "Space Planning & 3D Visualisation",
    desc: "Every rupee committed on paper before work begins — measured drawings, photoreal 3D views and itemised budgets you approve in daylight.",
    points: ["Measured site drawings", "Photoreal 3D renders", "Itemised, transparent budgets"],
    image: u("photo-1646987916641-1f3c8992daa2"),
  },
  {
    num: "05",
    title: "Commercial & Hospitality",
    desc: "Offices, clinics, cafés and boutique retail — spaces that carry the brand, survive footfall and stay easy to maintain.",
    points: ["Offices & studios", "Cafés & boutique retail", "Clinics & wellness spaces"],
    image: u("photo-1706074740295-d7a79c079562"),
  },
  {
    num: "06",
    title: "Styling, Art & Material Curation",
    desc: "The final layer that makes a house feel collected, not decorated — art, objects, linen, lighting scenes and the baths and vanities in between.",
    points: ["Art & object curation", "Lighting scenes & automation", "Stone, tile & finish palettes"],
    image: IMG.bathroom,
  },
];

export const PROCESS = [
  {
    num: "01",
    title: "Discovery",
    duration: "Week 1–2",
    desc: "We study your site in daylight and at dusk, map how each family member lives in it, and agree on a budget envelope before a single line is drawn.",
    deliverables: ["Site study", "Lifestyle mapping", "Budget alignment"],
  },
  {
    num: "02",
    title: "Design",
    duration: "Week 3–6",
    desc: "Concept direction, photoreal 3D visualisation of every key room, and material boards you can touch — revised with you until it feels inevitable.",
    deliverables: ["Concept direction", "3D architectural views", "Material boards"],
  },
  {
    num: "03",
    title: "Curate",
    duration: "Week 6–8",
    desc: "Stone slabs chosen in person, joinery detailed millimetre by millimetre, fabrics, art and lighting sourced from our craft partners across India.",
    deliverables: ["Material & vendor selection", "Joinery detailing", "Lighting plans"],
  },
  {
    num: "04",
    title: "Execute",
    duration: "8–16 weeks",
    desc: "Our own site teams, weekly photo-reports and a live cost sheet. One project manager, one WhatsApp group, zero surprises.",
    deliverables: ["Turnkey site management", "Weekly QC reports", "Live cost tracking"],
  },
  {
    num: "05",
    title: "Style & Handover",
    duration: "Final week",
    desc: "Staging, art, linen and lighting scenes — then the keys, a documented warranty folder and aftercare that answers the phone.",
    deliverables: ["Styling & art placement", "Warranty documentation", "Aftercare & servicing"],
  },
];

export const PROJECTS = [
  {
    id: "monolith-residence",
    title: "The Monolith Residence",
    location: "Jubilee Hills",
    category: "Villa",
    area: "6,200 sq.ft",
    year: "2024",
    scope: "Turnkey interiors · Bespoke joinery",
    cover: u("photo-1704040686413-2c607dbd2f06"),
    images: [u("photo-1704040686413-2c607dbd2f06"), u("photo-1776362355123-ca966d36e29c")],
    narrative:
      "A double-height living room in travertine and walnut, carved around the family's twelve-foot Raas-Leela canvas. Hidden bronze reveals wash the stone at night; the staircase floats past a two-storey fenestration that keeps the Deccan sun honest.",
  },
  {
    id: "glasshouse-penthouse",
    title: "The Glasshouse Penthouse",
    location: "Banjara Hills",
    category: "Penthouse",
    area: "4,800 sq.ft",
    year: "2024",
    scope: "Full home · Kitchen & bar",
    cover: u("photo-1632583824020-937ae9564495"),
    images: [u("photo-1632583824020-937ae9564495"), u("photo-1642976975710-1d8890dbf5ab")],
    narrative:
      "A chef's kitchen under a chandelier of blown glass, and a marble island cut from a single quarried block. The terrace deck reads the city skyline through frameless glass; interiors stay in warm oak and smoke.",
  },
  {
    id: "verdant-suite",
    title: "Verdant Executive Suite",
    location: "Gachibowli",
    category: "Apartment",
    area: "3,400 sq.ft",
    year: "2023",
    scope: "Interior design · Art curation",
    cover: u("photo-1646987916641-1f3c8992daa2"),
    images: [u("photo-1646987916641-1f3c8992daa2"), u("photo-1642541070065-3912f347e7c6")],
    narrative:
      "For a family that moved from Singapore: soft-neutral rooms with custom art, warm ambient lighting and storage that disappears into plaster. Quietly precise, entirely liveable.",
  },
  {
    id: "atelier-kitchen",
    title: "Atelier Kitchen House",
    location: "Kondapur",
    category: "Kitchen",
    area: "980 sq.ft",
    year: "2023",
    scope: "Modular kitchen · Dining",
    cover: u("photo-1600684388091-627109f3cd60"),
    images: [u("photo-1600684388091-627109f3cd60"), u("photo-1758448755927-e5c5ae14790c")],
    narrative:
      "A cook's kitchen in matte oak and honed granite — handle-less lines, a scullery behind the scenes, and a breakfast island positioned for the morning sun. German hardware, Indian stone.",
  },
  {
    id: "meridian-workspace",
    title: "Meridian Workspace",
    location: "HITEC City",
    category: "Commercial",
    area: "12,000 sq.ft",
    year: "2024",
    scope: "Office design · Build-out",
    cover: u("photo-1706074793638-da28b90ea8ae"),
    images: [u("photo-1706074793638-da28b90ea8ae"), u("photo-1705909770198-7e83c24e1616")],
    narrative:
      "A product company's headquarters that feels warm rather than corporate — acoustically panelled focus rooms, a tea pavilion at its heart, and daylight threaded through the entire floor plate.",
  },
  {
    id: "casa-terra",
    title: "Casa Terra",
    location: "Old City",
    category: "Villa",
    area: "5,100 sq.ft",
    year: "2025",
    scope: "Renovation · Heritage modern",
    cover: u("photo-1691036561573-4b76998b60de"),
    images: [u("photo-1691036561573-4b76998b60de"), u("photo-1564078516393-cf04bd966897")],
    narrative:
      "A 1970s family home restored rather than replaced — lime-plastered walls, original terrazzo repaired by old craftsmen, and a restrained layer of contemporary furniture and art on top.",
  },
];

export const PROJECT_CATEGORIES = [
  "All",
  "Villa",
  "Penthouse",
  "Apartment",
  "Kitchen",
  "Commercial",
];

export const TESTIMONIALS = [
  {
    quote:
      "Aurea turned our villa into a home that feels quietly grand — every evening, the light does something new to these walls.",
    name: "Ananya & Rohan Reddy",
    project: "The Monolith Residence, Jubilee Hills",
  },
  {
    quote:
      "The most disciplined site execution we have seen in Hyderabad. Handover on the promised day, with styling done to the last shelf.",
    name: "Keerthana Rao",
    project: "The Glasshouse Penthouse, Banjara Hills",
  },
  {
    quote:
      "They designed our HITEC City office to feel warm, not corporate. Clients walk in and ask who did it.",
    name: "Aditya Mehta",
    project: "Meridian Workspace, HITEC City",
  },
];

export const VALUES = [
  {
    title: "Warmth over spectacle",
    desc: "Rooms should embrace you at the end of a long day — not perform for a camera. We design for the ordinary Tuesday, not only the housewarming.",
  },
  {
    title: "Craft over catalogue",
    desc: "Nothing off the shelf that could be made to measure. Our carpenters, stonemasons and metalworkers build what we draw, and we draw what they can build.",
  },
  {
    title: "Clarity in every rupee",
    desc: "Itemised budgets, live cost sheets, no 'variation' ambushes. You always know what was spent, on what, and why.",
  },
];
